import { useQuery } from '@tanstack/react-query'
import { fetchCounties, fetchCounty } from 'utility/queries/county'

export const useAllCounties = () => {
	return useQuery({
		enabled: true,
		queryKey: ['allCounties'],
		queryFn: async () => {
			let counties = await fetchCounties()
			if (counties && counties.length) {
				counties = counties.filter((county) => county.active)
			}

			return await Promise.all(
				counties.map(async (county) => {
					return await fetchCounty({
						county: county?.name,
						state: 'texas',
					})
				}),
			)
		},
	})
}
